<template>
  <div class="serviceContent">
    <div class="backimg">
      <img
        :src="img"
        alt=""
        style=" width: 100%;height: 100%;vertical-align:middle;"
      />
      <div class="betweencenter">
        <div class="real">
          <div class="tis bigcolor">{{$t('promise.title')}}</div>
          <div class="tixt" style="font-size:30px;color:#ccc;">
            {{$t('promise.text')}}
          </div>
        </div>
      </div>
    </div>
    <div style="margin:60px 0;">
      <h1>{{$t('promise.header')}}</h1>
      <div class="botcolor">Service system</div>
    </div>
    <div class="contents">
      <div class="navs">
        <div class="list">
          <div class="wis" v-for="(item, it) in $t('promise.textlist')" :key="it">
            <div class="jiesh">
              <p class="tixt">{{ item.name }}</p>
            </div>
            <div class="textli">
              <ul>
                <li
                  v-for="(i, index) in item.litext"
                  :key="index"
                  class="colors"
                  style="text-align:left;margin-left:30px;"
                >
                  <img
                    src="../../assets/img/us/right.png"
                    alt=""
                    style="vertical-align:middle;margin-right:5px;"
                  />
                  <span :title="i.title">{{ i.title | indenllipsis}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="wis" v-for="(item, it) in $t('promise.textlists')" :key="it">
            <div class="jiesh">
              <p class="tixt">{{ item.name }}</p>
            </div>
            <div class="textli">
              <ul>
                <li
                  v-for="(i, index) in item.litext"
                  :key="index"
                  class="colors"
                  style="text-align:left;margin-left:30px;"
                >
                  <img
                    src="../../assets/img/us/right.png"
                    alt=""
                    style="vertical-align:middle;margin-right:5px;"
                  />
                  <span :title="i.title">{{ i.title |indenllipsis}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      img: require("../../assets/img/us/banner2.png"),
      textlist: [
        {
          name: "网管保障服务",
          litext: [
            {
              title: "24 x 7 主动式监控设备与链路"
            },
            {
              title: "问题根源分析和故障管理"
            },
            {
              title: "性能、配置、资产管理"
            },
            {
              title: "网络动态分析、报表、建议"
            }
          ],
          type: 1
        },
        {
          name: "设备维护服务",
          litext: [
            {
              title: "多厂家产品的现场和备件服务"
            },
            {
              title: "事件收集、关联、上报"
            },
            {
              title: "远程配置"
            },
            {
              title: "安全防护报告"
            },
            {
              title: "现场工程师"
            }
          ],
          type: 3
        }
      ],
      textlists: [
        {
          name: "电话技术支持服务",
          litext: [
            {
              title: "全年365天，每天7×24 400号服务热线"
            },
            {
              title: "多厂家产品支持，单一联络点"
            },
            {
              title: "问题上报"
            }
          ],
          type: 2
        },
        {
          name: "故障处理相应SLA指标",
          litext: [
            {
              title: "首通故障响应电话——10分钟"
            },
            {
              title: "首封故障邮件——30分钟"
            },
            {
              title: "故障进度反馈——60分钟"
            }
          ],
          type: 4
        }
      ]
    };
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="scss">
.serviceContent {
  // 标题
  .backimg {
    position: relative;
    overflow: hidden;
    .betweencenter {
      width: 1200px;
      margin: 0 auto;
      .real {
        position: absolute;
        top: 150px;
        z-index: 1000;
        text-align: left;
        .tis {
          // width: 420px;
          letter-spacing: 0px;
          line-height: 16px;
          font-size: 48px;
        }
        .tixt {
          width: 460px;
          margin-top: 36px;
          line-height: 30px;
          font-size: 14px;
          letter-spacing: 0px;
        }
      }
    }
  }
  .contents {
    width: 100%;
    margin: 0 auto;
    .navs {
      width: 1202px;
      height: 674px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      background: url("../../assets/img/us/center.png") no-repeat center center;
      background-size: 100% 100%;
      margin-bottom: 60px;
      .list {
        width: 50%;
        height: 100%;
        .wis {
          width: 310px;
          height: 54%;
          box-sizing: border-box;
        }
      }
      .jiesh {
        .tixt {
          font-weight: 700;
          color: #333;
          font-size: 18px;
          margin-top: 18px;
          margin-bottom: 10px;
        }
      }
      .textli {
        height: 240px;
        border-radius: 15px;
        padding: 10px;
        box-sizing: border-box;
        li {
          line-height: 2.3;
        }
      }
      .list:nth-child(1) {
        .wis:nth-child(1) {
          padding-top: 20px;
        }
        .wis:nth-child(2) {
          padding-top: 25px;
        }
      }
      .list:nth-child(2) {
        .wis:nth-child(1) {
          padding-top: 20px;
          float: right;
        }
        .wis:nth-child(2) {
          float: right;
          padding-top: 25px;
        }
      }
    }
  }
}
</style>
